import React, { useMemo } from 'react'
import { StepWizardChildProps } from 'react-step-wizard'

import { useTranslation } from '../../../../i18n'

import { FormProvider, useForm } from 'react-hook-form'
import FButton from '../../../../components/BaseComponents/FButton'
import FHeading1 from '../../../../components/BaseComponents/Text/FHeading1'
import FParagraph from '../../../../components/BaseComponents/Text/FParagraph'

import { defaultMargin } from '../../../../components/BaseComponents/constants'
import FNeedHelpCTA from '../../../../components/BaseComponents/FNeedHelpCTA'
import SBox from '../../../../components/opinionless/SBox'
import FInputRadioGroup from '../../../../components/BaseComponents/FInputRadioGroup'
import FButtonPrevious from 'components/BaseComponents/FButton/FPreviousButton'
import { useBenefitsAnswersMutation } from '../../../../types/graphql'
import { ga4_useTitle } from 'utils/ga4'

interface Props {
    onFinish: () => void
    personId?: any
}

const NoBenefitsFoundStep: React.FC<Props> = (props: Props & StepWizardChildProps) => {
    const form = useForm({ shouldFocusError: false })
    const { t } = useTranslation(window.LANG_NS)

    const [saveBenefitAnswer, { loading }] = useBenefitsAnswersMutation()

    ga4_useTitle('No interactions found')

    const onSubmit = async (values) => {
        if (values.no_benefit_decision === 'speak_with_benefits_counselor') {
            props.nextStep()
        } else {
            await saveBenefitAnswer({
                variables: {
                    answers: [
                        {
                            personId: props.personId,
                            category: 'DECLINE_SPEAK_COUNSELOR',
                            answer: 'true',
                        },
                    ],
                },
            })
            props.onFinish()
        }
    }

    const radioDataArray = useMemo(() => {
        return [
            {
                text: t('i_want_participate'),
                id: 'i_want_participate',
            },
            {
                text: t('speak_with_benefits_counselor'),
                id: 'speak_with_benefits_counselor',
            },
        ]
    }, [t])

    return (
        <React.Fragment>
            <FormProvider {...form}>
                <SBox as={'form'} onSubmit={form.handleSubmit(onSubmit)}>
                    <FButtonPrevious onClick={props.previousStep} />
                    <FHeading1 text={t('ssi_no_benefits_interaction')}></FHeading1>
                    <FParagraph text={t('ssi_no_benefits_interaction_description')} />
                    <FInputRadioGroup
                        radioDataArray={radioDataArray}
                        name={'no_benefit_decision'}
                        id={'no_benefit_decision'}
                        minimumSelection={1}
                    />
                    <FButton
                        buttonType={'filled'}
                        type={'submit'}
                        loading={loading}
                        marginTop={defaultMargin}
                        ga4_key={t('continue', { lang: 'en' })}
                    >
                        {t('continue')}
                    </FButton>
                    <FNeedHelpCTA
                        url={`${
                            window.PERSON?.applicationDetails[0].program?.urlFragment || window.PROGRAM.urlFragment
                        }/help`}
                        text={t('need_help_question')}
                    />
                </SBox>
            </FormProvider>
        </React.Fragment>
    )
}

export default NoBenefitsFoundStep
